import React, { useContext } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useModal } from '../../../../../../hooks/Modal';
import { SearchMyCollectionsContext } from '../..';
import * as S from './styled';

export const ModalChooseCancelMethod = () => {
  const { Modal } = useModal();

  const { openCancelPickupModal, openCancelMultipleModal } = useContext(
    SearchMyCollectionsContext
  );

  return (
    <Modal preventClose>
      <Stack spacing={2}>
        <S.ModalTitle>Atenção</S.ModalTitle>
        <S.ModalText>
          Deseja utilizar o mesmo "motivo" para todas as notas?
        </S.ModalText>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="attention"
            onClick={() => {
              openCancelMultipleModal();
            }}
          >
            Não
          </Button>
          <Button
            type="button"
            variant="contained"
            onClick={() => {
              openCancelPickupModal();
            }}
          >
            Sim
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};
